import { ADD_DETAILS, CHOOSE, HOW } from "../core-modules/constants";

import Box from "./Box";
import Button from "./Button";
import ChevronBlackIcon from "../assets/chevron-black.svg";
import ChevronIcon from "../assets/chevron.svg";
import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";
import { useAppContext } from "./AppContext";

function ProgressButton({ step, disabled, label, hasChevron, color }) {
  const { setCurrentStep } = useAppContext();
  return (
    <Button
      m="5px"
      onClick={() => {
        setCurrentStep(step);
      }}
      disabled={disabled}
      display="flex"
      alignItems="center"
    >
      {hasChevron && (
        <Box mr="7px">
          {color === "foreground" ? <ChevronBlackIcon /> : <ChevronIcon />}
        </Box>
      )}
      <Text
        color={color}
        fontWeight={700}
        fontFamily="bold"
        underlineRollover={!disabled}
      >
        {label}
      </Text>
    </Button>
  );
}

ProgressButton.propTypes = {
  step: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  hasChevron: PropTypes.bool.isRequired,
};

function Progress() {
  const { currentStep, takebackItems } = useAppContext();

  return (
    <Box px="4vw" display="flex" justifyContent="center" flexWrap="wrap">
      <ProgressButton
        step={HOW}
        disabled={currentStep === HOW}
        color="foreground"
        label="How"
        hasChevron={false}
      />
      <ProgressButton
        step={CHOOSE}
        disabled={currentStep === CHOOSE}
        color={currentStep === HOW ? "midground" : "foreground"}
        label="Choose items"
        hasChevron={true}
      />

      <ProgressButton
        step={ADD_DETAILS}
        disabled={takebackItems.length === 0 || currentStep === ADD_DETAILS}
        color={currentStep === ADD_DETAILS ? "foreground" : "midground"}
        label="Add details"
        hasChevron={true}
      />

      <Box m="5px" disabled display="flex" alignItems="center">
        <Box mr="7px">
          <ChevronIcon />
        </Box>
        <Text color="midground" fontWeight={700} fontFamily="bold">
          Complete
        </Text>
      </Box>
    </Box>
  );
}

export default Progress;
